/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancerVerticalApplicationStatus = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Refused: 'REFUSED',
    Removed: 'REMOVED'
} as const;
export type FreelancerVerticalApplicationStatus = typeof FreelancerVerticalApplicationStatus[keyof typeof FreelancerVerticalApplicationStatus];


export function instanceOfFreelancerVerticalApplicationStatus(value: any): boolean {
    for (const key in FreelancerVerticalApplicationStatus) {
        if (Object.prototype.hasOwnProperty.call(FreelancerVerticalApplicationStatus, key)) {
            // @ts-ignore
            if (FreelancerVerticalApplicationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancerVerticalApplicationStatusFromJSON(json: any): FreelancerVerticalApplicationStatus {
    return FreelancerVerticalApplicationStatusFromJSONTyped(json, false);
}

export function FreelancerVerticalApplicationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerVerticalApplicationStatus {
    return json as FreelancerVerticalApplicationStatus;
}

export function FreelancerVerticalApplicationStatusToJSON(value?: FreelancerVerticalApplicationStatus | null): any {
    return value as any;
}

